// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"353":"fc0a4963","406":"000ffc43","435":"83e8f7b6","522":"807e48aa","787":"e7905c81","808":"8e485795"}[chunkId] + ".chunk.js";
};